import { render, staticRenderFns } from "./QrPage.vue?vue&type=template&id=82052872&"
import script from "./QrPage.vue?vue&type=script&lang=ts&"
export * from "./QrPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports